import React, { useState } from 'react';
import './CalculatorPage.css';

function ChaldeanNumerologyCalculator() {
  const [name, setName] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculate = (inputName) => {
    // Placeholder for Chaldean Numerology calculation logic
    if (!inputName) return null;
    let sum = 0;
    const nameMap = {
      'A': 1, 'I': 1, 'J': 1, 'Q': 1, 'Y': 1,
      'B': 2, 'K': 2, 'R': 2,
      'C': 3, 'G': 3, 'L': 3, 'S': 3,
      'D': 4, 'M': 4, 'T': 4,
      'E': 5, 'H': 5, 'N': 5, 'X': 5,
      'U': 6, 'V': 6, 'W': 6,
      'O': 7, 'Z': 7,
      'F': 8, 'P': 8
    };

    for (let i = 0; i < inputName.length; i++) {
      const char = inputName[i].toUpperCase();
      if (nameMap[char]) {
        sum += nameMap[char];
      }
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!name) {
      setError('Please enter a name.');
      return;
    }

    const calculated = calculate(name);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (num) => {
    return `Chaldean Numerology Number ${num}: This is a placeholder explanation for Chaldean Numerology Number ${num}.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Chaldean Numerology Calculator",
    "description": "Calculate your Chaldean Numerology number and understand its significance.",
    "url": "https://www.yourwebsite.com/chaldean-numerology-calculator",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Chaldean Numerology",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/chaldean-numerology-calculator?name={name}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=name"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Chaldean Numerology Calculator</h1>
      <p className="text-center">Enter your name to discover your Chaldean Numerology number.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="name">Enter Your Name:</label>
          <input
            type="text"
            id="name"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., John Doe"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Calculate Chaldean Numerology</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Chaldean Numerology Number is: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default ChaldeanNumerologyCalculator;
